<template>
  <div class="session-widget">
    <div class="d-flex align-items-center justify-content-between mb-2">
      <div class="d-flex align-items-center">
        <span class="badge badge-primary text-white mr-2 p-1 font-size-12">
          <i class="fe fe-calendar"></i> Current Session
        </span>
      </div>
      <div v-if="totalSessions !== undefined && totalSessions !== null" class="text-right">
        <span class="badge badge-light-primary text-primary font-weight-bold font-size-12 px-2 py-1">
          Total Sessions: {{ totalSessions }}
        </span>
      </div>
    </div>

    <div class="mt-2" v-if="session">
      <h4 class="text-dark font-weight-bold mb-2">
        {{ session.name || 'N/A' }}
      </h4>
      <div class="font-size-13 text-gray-7 mb-1" v-if="session.start_date">
        <i class="fe fe-clock mr-1 text-muted"></i>
        <span>{{ startDate }} – {{ endDate }}</span>
      </div>
      <div class="font-size-12 text-muted mt-2" v-if="dateToday">
        <i class="fe fe-check-square mr-1 text-success"></i>
        Today: <strong>{{ dateToday }}</strong>
      </div>
    </div>
    <div class="text-muted mt-2" v-else>
      No active session set
    </div>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  name: 'NeoCurrentSessionWidget',
  props: {
    session: {
      type: Object,
      default: () => ({}),
    },
    totalSessions: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    startDate() {
      return this.session && this.session.start_date ? moment(this.session.start_date).format('LL') : ''
    },
    endDate() {
      return this.session && this.session.end_date ? moment(this.session.end_date).format('LL') : ''
    },
    dateToday() {
      return moment().format('LL')
    },
  },
}
</script>

<style scoped>
.session-widget {
  width: 100%;
}
.badge-light-primary {
  background-color: #e6f7ff;
  border: 1px solid #91d5ff;
}
</style>
